import React, { useRef } from 'react';

import { useReactToPrint } from 'react-to-print';

import { PrinterDiv } from './styles';

import ComponentToPrintIfood from '../ComponentToPrintIfood';
import { useToast } from '../../../hooks/toast';
import { IIfoodOrder } from '../../../interfaces/IIfoodOrder';

interface CustomPrinterProps extends React.HTMLAttributes<HTMLDivElement> {
  ifoodOrder: IIfoodOrder;
  children: React.ReactNode;
}

const CustomPrinterIfood: React.FC<CustomPrinterProps> = ({
  ifoodOrder,
  children,
  ...rest
}) => {
  const inputEl = useRef(null);

  const { addToast } = useToast();

  const handlePrint = useReactToPrint({
    content: () => inputEl.current,
  });

  return (
    <>
      <PrinterDiv
        onClick={() => {
          handlePrint && handlePrint();
          addToast({
            title: 'Gerando impressão...',
            type: 'info',
          });
        }}
        {...rest}
      >
        {children}
      </PrinterDiv>

      <div style={{ display: 'none' }}>
        <ComponentToPrintIfood ref={inputEl} ifoodOrder={ifoodOrder} />
      </div>
    </>
  );
};

export default CustomPrinterIfood;
